import {
  Box,
  Breadcrumbs as JoyBreadcrumbs,
  breadcrumbsClasses,
  styled,
  Typography,
} from '@mui/joy';

export const Breadcrumbs = styled(JoyBreadcrumbs)({
  display: 'flex',
  height: 32,
  fontSize: 14,
  fontWeight: 500,
  padding: 0,
  gap: '4px',

  [`& .${breadcrumbsClasses.separator}`]: {
    svg: {
      color: 'inherit',
    },
  },
});

export const Wrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const Label = styled(Typography)({
  marginRight: 4,
});

export const Text = styled(Typography)(({ theme }) => ({
  color: theme.palette.neutral[600],
}));
